import React from 'react';
import { Button, Form, Input } from 'antd';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import { useAppDispatch } from '../store/hooks';
import { forgotPassword } from '../store/slices/authSlice';

interface ForgotPasswordFormValues {
  email: string;
}

const ForgotPassword: React.FC = () => {
  const [form] = Form.useForm<ForgotPasswordFormValues>();
  const dispatch = useAppDispatch();

  const handleSubmit = (values: ForgotPasswordFormValues): void => {
    dispatch(forgotPassword(values));
  };

  return (
    <div className="gx-login-container">
      <Container>
        <Row>
          <Col>
            <div className="gx-login-content">
              <div className="gx-login-header">
                <img src={require('../img/logo.svg')} alt="" className="img-fluid" />
              </div>
              <hr />
              <div className="gx-mb-4 gx-text-center">
                <h2>Forgot Password</h2>
              </div>

              <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                className="gx-login-form gx-form-row0"
              >
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      type: 'email',
                      message: 'The input is not valid email',
                    },
                    {
                      required: true,
                      message: 'Please enter your email',
                    },
                  ]}
                >
                  <Input
                    prefix={<MailOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                    type="email"
                    placeholder="Email"
                  />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" style={{ width: '100%' }} htmlType="submit">
                    Send
                  </Button>
                </Form.Item>
                <Form.Item className="text-center">
                  <Link className="gx-login-form-forgot" to="/">
                    <ArrowLeftOutlined /> Back to Sign In
                  </Link>
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgotPassword;
